import type { ApolloCache } from '@apollo/client';

/**
 * Сбросить соответствие навыков у всех вакансий в кеше (ТЗ 0073).
 *
 * Оценка навыка и сохранение профиля меняют «Twoje umiejętności: 4 z 5» на
 * каждой вакансии. `refetchQueries` по имени сюда не годится: на карте
 * навыков лента не смонтирована (тихий no-op), а пропущенный запрос отдал бы
 * 400. Выброшенное поле делает данные открытых ленты и панели неполными, и
 * Apollo сам перезапрашивает их; несмонтированные — при следующем показе.
 */
export const evictVacancySkillMatch = (cache: ApolloCache<unknown>) => {
  const data = cache.extract() as Record<string, unknown>;
  Object.keys(data)
    .filter((id) => id.startsWith('VacancyType:'))
    .forEach((id) => cache.evict({ id, fieldName: 'skillMatch' }));
  cache.gc();
};
